/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '~/common/types/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type BatchChangeRequestsJobExportDryRunResultInput = {
  jobRunId: string;
  tenantId: string;
};

export type ExportBatchChangeRequestsJobDryRunResultQueryVariables = Exact<{
  input: Types.BatchChangeRequestsJobExportDryRunResultInput;
}>;


export type ExportBatchChangeRequestsJobDryRunResultQuery = { cnutExportBatchChangeRequestsJobDryRunResult: string };


export const ExportBatchChangeRequestsJobDryRunResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExportBatchChangeRequestsJobDryRunResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BatchChangeRequestsJobExportDryRunResultInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cnutExportBatchChangeRequestsJobDryRunResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ExportBatchChangeRequestsJobDryRunResultQuery, ExportBatchChangeRequestsJobDryRunResultQueryVariables>;